"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppLocaleFromStorage = void 0;
const features_1 = require("../features");
const getAppLocaleFromStorage = () => {
    const key = 'app_locale__';
    const store = new features_1.Store({ prefix: '__ods_', storage: features_1.StorageLocation.Local });
    return store.getItem(key);
};
exports.getAppLocaleFromStorage = getAppLocaleFromStorage;
//# sourceMappingURL=appLocale.js.map